module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAJCAYAAAD6reaeAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAIGNIUk0AAHolAACAgwAA+f8AAIDpAAB1MAAA6mAAADqYAAAXb5JfxUYAAABLSURBVHjaTM1BEcAgEEPRSEAKEioFJ5VYCUhAwusFmD3tzE82PwiefYMEDR9GhUHHOkHK2w0qDF6sCsZu9hT72hPXPg+oola3/wEAmcOQcvEG/yIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/components/page-footer/page-png/rentagle.png
// module id = ./src/components/page-footer/page-png/rentagle.png
// module chunks = index